const css = `.Ybewka__day{width:44px;height:36px;justify-content:center;align-items:center;display:flex;position:relative}.Ybewka__day.Ybewka__disabled{cursor:not-allowed;pointer-events:all}.Ybewka__day-v2{width:58px;height:46px;justify-content:center;align-items:center;display:flex;position:relative}.Ybewka__day-v2.Ybewka__disabled{cursor:not-allowed;pointer-events:all}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"day-v2":"Ybewka__day-v2","day":"Ybewka__day","disabled":"Ybewka__disabled"};
